export default function useAppName(){
    return "OccuSense"
}